<div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

        <div class="row">

          <!--<div class="col-md-3" *ngIf="PatientDetails">

    </div>-->
          <div class="col-md-3 line-height-17px">
            Add/Edit of {{Title}}
          </div>

          <div class="col-md-7 line-height-17px">
            <!--<label class="margin-bottom-0px">{{ sectionData.Title }}</label>-->
            <label class="margin-bottom-0px font-weight-normal" *ngIf="TemplateName">{{TemplateName}}</label>
            <div><label class="margin-bottom-0px font-size-14 font-weight-normal" *ngIf="Date">{{Date|date:'dd-MM-yyyy'}}</label></div>
            <div class="row font-weight-700">
              <!--<div class="col-md-4">
          <label class="font-size-14 font-weight-normal margin-bottom-0px">Section Name</label>
        </div>:-->
              <div class="col-md-12  color-title padding-right-0px">
                <label *ngIf="TitleName" class="font-size-16px font-weight-bold margin-bottom-0px  margin-top-3px">{{TitleName}}</label>

              </div>
            </div>
            <!--<div class="row font-weight-700">
        <div class="col-md-2">
          <label class="font-size-14 font-weight-normal margin-bottom-0px"> Sign2 </label>
        </div>:
        <div class="col-md-8 font-size-14 font-weight-normal">

          <label *ngIf="Sign2" class="font-size-14 font-weight-normal margin-bottom-0px">{{Sign2}}</label>
        </div>
      </div>-->
          </div>

          <div class="col-md-2 ">
            <!--<button type="button" class="close float-right" data-dismiss="modal"
              (click)="activeModal.dismiss('Cross click')"
              aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>-->
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="activeModal.close('Close click')">Close</button>
            <button (click)="onSubmit()" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-15px ">Save</button>
          </div>
        </div>
        <!--{{ sectionData.Title }}-->
        <!--<div  class="row" *ngFor="let l of GridRow.Cells">
          {{l.Data.Title}}
        </div>-->


      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px" >
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px  padding-bottom-5px">




            <div class="row" *ngIf="Mode=='Edit'">

              <div class="col-md-12 health-records-modal">
                <div class="row margin-left-auto">
                  <div class="col-md-12 padding-l-0px" *ngFor="let field of  GridRow.Cells">

                    <div [ngSwitch]="field.ValueType">
                      <div class="row" *ngSwitchCase="'Bool'">
                        <auto-gen-bool class="col-md-12" [Data]="field" [field]="field.Data">
                        </auto-gen-bool>
                      </div>
                      <div class="row" *ngSwitchCase="'List'">
                        <auto-gen-list class="col-md-12 padding-l-0px padding-right-0px" [Data]="field" [field]="field.Data">
                        </auto-gen-list>
                      </div>
                      <div class="row margin-top-5px" *ngSwitchCase="'Text'">
                        <auto-gen-text class="col-md-12" [field]="field"></auto-gen-text>
                      </div>
                      <div class="row margin-top-5px" *ngSwitchCase="'CVS'">
                        <auto-gen-cvs class="col-md-12" [field]="field"></auto-gen-cvs>
                      </div>
                      <div class="row margin-top-5px" *ngSwitchCase="'CsvList'">
                        <auto-gen-csvlist class="col-md-12" [field]="field.Data"  [Data]="field" ></auto-gen-csvlist>
                      </div>
                      <div class="row" *ngSwitchCase="'Date'">
                        <auto-gen-date class="col-md-12" [field]="field"></auto-gen-date>
                      </div>

                      <div class="row" *ngSwitchDefault>
                        <label class="red-bg">Other: {{field.Data.Title}} , Field Type:{{field.Data.ValueType}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="Mode=='Add'">

              <div class="col-md-12 health-records-modal">
                <div class="row margin-left-auto">
                  <div class="col-md-12 padding-l-0px" *ngFor="let field of  GridRow.Cells">

                    <div [ngSwitch]="field.ValueType">
                      <div class="row" *ngSwitchCase="'Bool'">
                        <auto-gen-bool class="col-md-12" [Data]="field" [field]="field.Data">
                        </auto-gen-bool>
                      </div>
                      <!--<div class="row" *ngSwitchCase="'List'">
    <auto-gen-list class="col-md-12 padding-l-0px padding-right-0px" [Data]="field" [field]="field">
    </auto-gen-list>
  </div>-->
                      <div class="row margin-top-5px" *ngSwitchCase="'Text'">
                        <auto-gen-text class="col-md-12" [field]="field"></auto-gen-text>
                      </div>
                      <div class="row margin-top-5px" *ngSwitchCase="'CVS'">
                        <auto-gen-cvs class="col-md-12" [field]="field"></auto-gen-cvs>
                      </div>
                      <div class="row margin-top-5px" *ngSwitchCase="'CsvList'">
                        <auto-gen-csvlist class="col-md-12" [field]="field"></auto-gen-csvlist>
                      </div>
                      <div class="row" *ngSwitchCase="'Date'">
                        <auto-gen-date class="col-md-12" [field]="field"></auto-gen-date>
                      </div>

                      <div class="row" *ngSwitchDefault>
                        <label class="red-bg">Other: {{field.Title}} , Field Type:{{field.ValueType}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>



           


            <!--<div class="card-footer text-align-center">
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
            </div>-->


















         
          <!--<div class="modal-footer float-right col-md-12">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-15px ">Save</button>
          </div>-->
        </form>
      </div>
    </div>
  </div>
</div>
